// extracted by mini-css-extract-plugin
module.exports = {"account":"account-module--account--26ac0","block":"account-module--block--2wEim","events":"account-module--events--ma-bv","todo":"account-module--todo--2VDRz"};